import {useState, useEffect} from "react";
import {useGetAgentIdByDomainName} from "../../api/agent";
import cookies from "../../utils/cookies";
import {useTranslation} from "react-i18next";
import {useNavigateTo} from "../../hooks/useNavigateTo";

export default function GetDomain({ children, mall = '' }) {
  const [domain, setDomain] = useState(false);
  const [error, setError] = useState();
  const { getAgent } = useGetAgentIdByDomainName();
  const { t } = useTranslation();
  const navigateTo = useNavigateTo();
  
  const getDomainInfo = async () => {
    
    let { data, error } = await getAgent();
    
    if (error) {
      return setError(true);
    }
    
    if (data) {
      let info = {
        ...data
      };
      delete info.priProtocal;
      delete info.enPriProtocal;
      delete info.regProtocal;
      delete info.enRegProtocal;
      // delete info.bottomInfo;
      delete info.enTermsAndConditions
      delete info.termsAndConditions
      
      cookies.set('agentInfo', info);
      cookies.set('MALLagentId', data.agentId);
      cookies.set('MALLaliasName', data.aliasName);
      setDomain(true);
    }
  };
  
  useEffect(() => {
    getDomainInfo();
    if (mall) {
      cookies.set('MALL', mall);
    }
  }, []);
  
  if (error) {
    return (
      <div className="absolute left-[50%] top-[50%]"
           style={{ transform: 'translate(-50%,-90%)' }}>{t('抱歉！出错了...')}</div>
    );
  }
  
  return domain ? (<>{children}</>) : <div></div>;
}
